import React, { useEffect, useState } from "react";
import "./JournalSec2.css";
import { Button, Card, Stack } from "react-bootstrap";
import { map } from "lodash";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { FiArrowRight } from "react-icons/fi";
import { getBlogs } from "../../../API/blog";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { Autoplay } from "swiper/modules";

import "swiper/css";
export const JournalSec2 = () => {
    const [windowWidth, setWindowWidth] = useState(900);
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        const fetchBlogs = async () => {
            const data = await getBlogs();

            const formatted = data.map(item => ({
                StoryId: item.id,
                slug: item.slug,
                category: item.category, // ✅ keep real category
                Title: item.title,
                ShortDescription: item.description,
                ImagePath: item.imageUrl,
            }));

            setBlogs(formatted);
        };

        fetchBlogs();
    }, []);

    // ✅ Categories (Tabs)
    const journalCategoriesData = [
        { CategoryName: "Community" },
        { CategoryName: "Destination" },
        { CategoryName: "Experience" },
        { CategoryName: "Wildlife" },
        { CategoryName: "Family Travel" },
        { CategoryName: "Tips & Advice" },
        { CategoryName: "Art & History" },
    ];

    useEffect(() => {
        if (typeof window !== "undefined") {
            setWindowWidth(window.innerWidth);
            const handleResize = () => setWindowWidth(window.innerWidth);
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }
    }, []);



    const [selected, setSelected] = useState("All Categories");
    const filteredStories =
        selected === "All Categories"
            ? blogs
            : blogs.filter(item => item.category === selected);

    return (
        <div className="journalsec4 standard-padding">
            <h4 className="heading">Journeys Worth Reading </h4>
            <Stack direction="horizontal" className="journalsec4-links-container">
                <p
                    className={`journalsec4-links ${selected === "All Categories" ? "journalsec4-links-selected" : ""}`}
                    onClick={() => setSelected("All Categories")}
                >
                    All Categories
                </p>

                {map(journalCategoriesData, (l) => (
                    <p
                        key={l.CategoryName}
                        className={`journalsec4-links ${selected === l.CategoryName ? "journalsec4-links-selected" : ""}`}
                        onClick={() => setSelected(l.CategoryName)}
                    >
                        {l.CategoryName}
                    </p>
                ))}
            </Stack>
            {filteredStories?.length ? (
                windowWidth > 900 ? (
                    <Stack className="journalsec4-content">
                        {map(filteredStories, (post) => (
                            <Stories
                                key={post.StoryId}
                                image={post.ImagePath}
                                title={post.Title}
                                content={post.ShortDescription}
                                StorySlug={post.slug}
                            />
                        ))}
                    </Stack>
                ) : (
                    <Stack gap={2} className="journalsec4-content">
                        <Swiper
                            spaceBetween={10}
                            slidesPerView={9}
                            loop={true}
                            modules={[Navigation, Pagination]}
                            navigation={{
                                nextEl: ".custom-next",
                                prevEl: ".custom-prev",
                            }}
                            pagination={{
                                el: ".custom-pagination",
                                clickable: true,
                            }}
                            breakpoints={{
                                0: { slidesPerView: 1 },
                                600: { slidesPerView: 1 },
                                900: { slidesPerView: 2 },
                                1200: { slidesPerView: 3 },
                            }}
                            className="journalsec2-swiper"
                        >
                            {map(filteredStories, (post) => (
                                <SwiperSlide >
                                    <Stories
                                        key={post.StoryId}
                                        image={post.ImagePath}
                                        title={post.Title}
                                        content={post.ShortDescription}
                                        StorySlug={post.slug}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>

                        {/* DOTS */}
                        <div className="custom-pagination"></div>
                    </Stack>
                )
            ) : (
                <Stack gap={2} className="journalsec4-content2">No Stories Found</Stack>
            )}
        </div>
    )
}

const Stories = ({ image, title, content, StorySlug }) => {
    const navigate = useNavigate()
    return (
        <Card className="journalsec4-card">
            <Card.Img style={{ height: "220px" }} alt="img" variant="top" src={image} />
            <Card.Body className="journalsec4-card-body" style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                <div>
                    <Card.Title className="journalsec4-card-title">{title.toLowerCase()
                        .split(" ")
                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(" ")}</Card.Title>
                    <Card.Text className="journalsec4-card-desc">
                        {content}
                    </Card.Text>
                </div>
                <Button className="journalsec4-card-button mt-4"
                    style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}
                    onClick={() =>
                        navigate(`/blog/${StorySlug}`)
                    }
                >EXPLORE  <FiArrowRight size={18} /></Button>
            </Card.Body>
        </Card>
    )
}